import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/cn';

// The outlined flag capsule. Distinct from StatusPill, which is filled.
export const flagPillVariants = cva(
  'inline-flex items-center justify-center rounded-[8px] border px-4 py-2 font-dusq text-[12px] font-medium',
  {
    variants: {
      tone: {
        positive: 'border-dusq-positive text-dusq-positive',
        warning: 'border-dusq-warning text-dusq-warning',
        negative: 'border-dusq-negative text-dusq-negative',
        // Blue is the explainers' "informational / interactive" meaning, distinct from
        // grey, which is reserved for inactive and closed.
        info: 'border-dusq-accent text-dusq-accent',
        neutral: 'border-dusq-border text-dusq-grey400',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export const FlagPill = React.forwardRef(({ className, tone, ...props }, ref) => (
  <span ref={ref} className={cn(flagPillVariants({ tone }), className)} {...props} />
));
FlagPill.displayName = 'FlagPill';
